export function cruiseSaleCalculation({
  cruiseSaleDetails,
  cruiseSaleAddOns,
  isGroupedPrice,
}) {
  let tempSchedulePrice = 0;
  if (isGroupedPrice) {
    tempSchedulePrice +=
      (cruiseSaleDetails?.[0]?.basicFare || 0) +
      (cruiseSaleDetails?.[0]?.portCharge || 0) +
      (cruiseSaleDetails?.[0]?.tax || 0) +
      (cruiseSaleDetails?.[0]?.tipping || 0);
  } else {
    tempSchedulePrice += cruiseSaleDetails.reduce(
      (prev, curr) =>
        prev +
        (curr.basicFare || 0) +
        (curr.portCharge || 0) +
        (curr.tax || 0) +
        (curr.tipping || 0),
      0,
    );
  }

  tempSchedulePrice += (cruiseSaleAddOns || []).reduce(
    (prevAddon, currAddon) => prevAddon + (currAddon.price || 0),
    0,
  );
  return tempSchedulePrice;
}

export function totalCruiseSaleCalculation({
  cruiseSales,
  discount,
  otherCost,
}) {
  let tempTotal: number = 0;
  tempTotal = cruiseSales.reduce((prev, curr) => {
    return (
      prev +
      cruiseSaleCalculation({
        cruiseSaleAddOns: curr.cruiseSaleAddOns,
        cruiseSaleDetails: curr.cruiseSaleDetails,
        isGroupedPrice: curr.isGroupedPrice,
      })
    );
  }, 0);

  tempTotal -= discount || 0;
  tempTotal += otherCost || 0;

  return tempTotal;
}

export function cruiseRescheduleCalculation({ cruiseSales }) {
  return cruiseSales.reduce(
    (prev, curr) => prev + (curr.rescheduleFee || 0),
    0,
  );
}
